module.exports = __webpack_public_path__ + "static/media/pen.6a5b3fd3.svg";